import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import {
  getMsalGuardConfig,
  getMsalInstance,
  getMsalInterceptorConfig,
} from '@vinnova/auth-internal';
import { ApimInterceptor, ETjansterModule } from '@vinnova/e-tjanster';
import { TranslationModule } from '@vinnova/translation';
import { ButtonModule } from '@vinnova/ui';
import * as i18nIsoCountries from 'i18n-iso-countries';
import * as en from 'i18n-iso-countries/langs/en.json';
import * as sv from 'i18n-iso-countries/langs/sv.json';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HoverOverlayService } from './core/services/hover-overlay.service';
import { LayoutComponent } from './layout/layout.component';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
i18nIsoCountries.registerLocale((sv as any).default);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
i18nIsoCountries.registerLocale(en as any);

// För att redirects inte fungerar i iframe så används popup.
export function msalInterceptorConfigFactory(
  router: Router,
): MsalInterceptorConfiguration {
  const { protectedResourceMap } = getMsalInterceptorConfig(
    environment.msalConfig,
  );
  return {
    get interactionType(): InteractionType.Popup | InteractionType.Redirect {
      return router.url.includes('/effekta')
        ? InteractionType.Popup
        : InteractionType.Redirect;
    },
    protectedResourceMap,
  };
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ButtonModule,
    ETjansterModule.forRoot(environment),
    TranslationModule.forRoot(environment),
    MsalModule.forRoot(
      getMsalInstance(environment.msalConfig, true),
      getMsalGuardConfig(),
      undefined, // Configen sätts i provider MSAL_INTERCEPTOR_CONFIG
    ),
    LayoutComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: msalInterceptorConfigFactory,
      deps: [Router],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApimInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    HoverOverlayService,
    { provide: LOCALE_ID, useValue: 'sv-SE' },
  ],
})
export class AppModule {}
